<template>
  <div>
    <el-dialog :title="title" :visible.sync="showModal" :width="modalWidth" :show-close="showClose" :before-close="bindSetCancel">
      <div class="modal_group_wrap">
        <slot />
        <div v-if="showButton" class="modal_foot_wrap">
          <el-button @click="bindSetCancel">取消</el-button>
          <el-button class="modal_sumbit" @click="bindSetSubmit">确定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: () => {
        return ''
      }
    },
    modalWidth: {
      type: String,
      default: () => {
        return '300px'
      }
    },
    showModal: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    showClose: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    showButton: {
      type: Boolean,
      default: () => {
        return true
      }
    }
  },
  data() {
    return {

    }
  },
  methods: {
    // 弹窗-取消按钮
    bindSetCancel() {
      this.$emit('cancel', {})
    },

    // 弹窗-确定按钮
    bindSetSubmit() {
      this.$emit('submit', {})
    }
  }
}
</script>
<style lang="less" scoped>
  .modal_group_wrap {
    width: 100%;

    .modal_foot_wrap {
      width: 100%;
      height: 50px;
      box-sizing: border-box;
      padding: 0 30px;
      display: flex;
      align-items: center;
      justify-content: flex-end;

      .modal_sumbit {
        margin-left: 10px;
        color: #fff;
        background: #43aab7;
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/modal/modal.vue